module.exports = __webpack_public_path__ + "static/img/mobile_pg_bottom.725a7b4d.png";